/*
 * @Description: 外场对接沙滩说 兔学堂和学习任务 列表
 * @Author: gaolei
 * @Date: 2024-09-18
 * @LastEditTime: 2024-10-15 16:15:39
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
import { updateUserInfo } from '@/utils/userInfo'
import { loading } from '@/utils/loading'
import dsBridge from 'dsbridge'
import router from '@/router'

// 判断是否是外场App
export const isOutFieldApp = window.navigator.userAgent.indexOf('outfield') > -1

export const isOutFieldHongMengApp = window.navigator.userAgent.indexOf('Jt-hongmeng-Web') > -1

// 在文件的顶部添加以下代码来扩展 Window 接口
declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

// 调用外场方法（使用 dsBridge）
const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (isOutFieldHongMengApp) {
      window?.jtJsBridge?.jtH5CallNativeApi(request, function (responseData: any) {
        if (responseData && typeof responseData === 'string') {
          try {
            const parsedResponse = JSON.parse(responseData)
            resolve(parsedResponse)
          } catch (error) {
            resolve(responseData)
          }
        } else {
          resolve(responseData)
        }
      })
    } else {
      dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
        // console.log('=======response: ' + responseData)
        if (responseData && typeof responseData === 'string') {
          try {
            const parsedResponse = JSON.parse(responseData)
            resolve(parsedResponse)
          } catch (error) {
            resolve(responseData)
          }
        } else {
          resolve(responseData)
        }
      })
    }
  })
}

// 获取外场token（使用 UserTokenChannel）
export const outFieldLogin = async () => {
  loading.show()
  try {
    const request = { method: 'SandsTalkTokenChannel', data: {} }
    const res = await callNative(request)
    // console.log(res, '用户Token信息')

    if (!res) {
      throw new Error('获取Token失败')
    }

    const resData = typeof res === 'string' ? JSON.parse(res) : res
    if (resData.code === -1) {
      // 错误直接退出到App，并提示错误信息
      outFieldShowToast(resData.message)
      outFieldCloseWebview()
      return {}
    }

    const authStore = useAuthStore()
    const { data } = resData
    if (!data) {
      throw new Error('Token不存在')
    }
    authStore.setAccessToken(data)
    localStorage.setItem('sandsTalkTenantId', '1000')
    localStorage.setItem('sandsTalkToken', data)
    await updateUserInfo()
    return data
  } catch (error) {
    // console.error('获取Token失败:', error);
    // showToast('获取Token失败')
    outFieldCloseWebview()
    return {}
  } finally {
    loading.hide()
  }
}

// 外场下载H5链接  (文件下载)
export const outFieldDownloadH5Url = (url: string, name: string) => {
  const request = { method: 'OpenFileChannel', data: { url, name } }
  callNative(request)
}

// 外场关闭webview
export const outFieldCloseWebview = async () => {
  const request = { method: 'FinishPageChannel' }
  await callNative(request)
}


/**
 * 注册 Native 调用 H5 的方法 ：app 调用H5
 * @param handler
 */
export function registerNative(handler: object | (() => any)) {
  // jtNativeCallH5Api 与原生协商固定
  dsBridge.register('jtNativeCallH5Api', handler)
}

/**
 * @Description 注册Native调用H5的方法，处理原生物理返回键和返回上级页面
 * 使用场景：安卓物理返回键、机型虚拟按键、滑动手势返回
 */
export const registerNativeAndPreviousH5 = () => {
  registerNative((result: any) => {
    console.log('registerNative', result)
    // 处理原生物理返回键
    const res = JSON.parse(result)
    if (res.method === 'BackChannel') {
      // console.log("返回上一页")
      outFieldCloseWebview()
    }
  })

  // 定义返回方法供原生调用（虚拟按键及滑动手势返回）
  dsBridge.register('jtNativeCallH5Api', function () {
    const isOutFieldApp = router.currentRoute.value.meta?.isOutFieldApp
    if (isOutFieldApp) {
      // console.log('手势返回app')
      outFieldCloseWebview()
    } else {
      router.go(-1)
    }
    return 'success'
  })
}

// 外场Toast提示
export const outFieldShowToast = (message: string) => {
  const request = { method: 'ToastChannel', data: { message } }
  callNative(request)
}
